import { Home, Building2, Sparkles, Truck, HardHat, Blinds, Phone } from "lucide-react";
import { Reveal, TEL, PHONE } from "./shared";

const services = [
  { icon: Home, title: "Residential Cleaning", text: "Regular & one-time cleans for apartments, condos and houses — kept fresh, tidy and spotless.", price: "$45 + GST / hour" },
  { icon: Building2, title: "Commercial & Office", text: "Reliable cleaning for offices and businesses, so your team walks into a pristine space every day.", price: "Custom quote" },
  { icon: Sparkles, title: "Deep Cleaning", text: "A complete top-to-bottom reset. We reach every hidden corner, baseboard and surface.", price: "$45 + GST / hour" },
  { icon: Truck, title: "Move-In / Move-Out", text: "Spotless transitions for empty homes — sanitized and ready for a fresh new start.", price: "$45 + GST / hour" },
  { icon: HardHat, title: "Post-Construction", text: "Dust and debris removal after renovations, leaving your new space perfectly clean.", price: "Custom quote" },
  { icon: Blinds, title: "Carpet & Window", text: "Refreshed carpets and streak-free windows that let the Edmonton light shine in.", price: "$45 + GST / hour" },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-grid" className="bg-[#FAFAFA] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.25em] text-pink-dark font-semibold mb-4">All Types of Cleaning</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-teal font-medium leading-tight">
            One trusted team for every kind of clean
          </h2>
          <p className="mt-5 text-lg text-teal-soft leading-relaxed">
            From routine tidy-ups to detailed deep cleans, we tailor every visit to your space and schedule.
            Residential cleaning is just <span className="text-teal font-medium">$45 + GST per hour</span> — offices &amp; industrial spaces are priced by custom quote.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.1}>
              <div
                data-testid={`service-card-${i}`}
                className="group h-full bg-white border border-blush rounded-3xl p-8 hover:shadow-[0_12px_40px_rgba(225,175,192,0.25)] hover:-translate-y-1 transition-all duration-300"
              >
                <span className="w-14 h-14 rounded-2xl bg-blush flex items-center justify-center text-teal group-hover:bg-pink group-hover:text-white transition-colors duration-300">
                  <s.icon size={26} strokeWidth={1.5} />
                </span>
                <h3 className="mt-6 font-serif-display text-2xl text-teal">{s.title}</h3>
                <p className="mt-3 text-teal-soft leading-relaxed">{s.text}</p>
                <div className="mt-5 pt-4 border-t border-blush flex items-baseline gap-2" data-testid={`service-price-${i}`}>
                  <span className="font-serif-display text-2xl text-teal">{s.price}</span>
                  {s.price === "Custom quote" && (
                    <span className="text-sm text-teal-soft">· by agreement</span>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-14 text-center">
          <a
            href={TEL}
            data-testid="services-call-button"
            className="inline-flex items-center gap-3 bg-teal text-white hover:bg-teal-dark rounded-full px-9 py-4 text-lg transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <Phone size={20} strokeWidth={1.5} /> Get your free quote: {PHONE}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
